import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-sales-team-edit',
  templateUrl: './sales-team-edit.component.html',
  styleUrls: ['./sales-team-edit.component.css']
})
export class SalesTeamEditComponent implements OnInit {

  constructor(private brandService:ServiceService,private router: Router) { }

  public model = Array()
 // public model = Array( new Date('7/15/1966'))
  minDate= new Date('1/1')
  maxDate= new Date('1/31')
 // calenderShown=false
  output:any=[]; //---store get() result--------
  DName="*"
  MName="*"
  TeamId:any
  MonthName:any
  selectedItems:any = [];
  Brand:any=[];
  searchEmployee:string='';
  Search_employee=""
  isShownEmployee=false;
  employee:any=[];
  data:any={
    _id:null,
    team_name:null,
    brand_name:null,
    brand_id:null,
    brand_manager_name:null,
    month:"",
    working_days:[],
    team_mates:[],
    brand_manager_id:null,

  }
  

  isShown: boolean = false;
  alert=""
  message=""
  department:any=[];
  TeamMates="*"

  Month=[{name:"January",id:"01",last:31},
         {name:"February",id:"02",last:28},
         {name:"March",id:"03",last:31},
         {name:"April",id:"04",last:30},
         {name:"May",id:"05",last:31},
         {name:"June",id:"06",last:30},
         {name:"July",id:"07",last:31},
         {name:"August",id:"08",last:31},
         {name:"September",id:"09",last:30},
         {name:"October",id:"10",last:31},
         {name:"November",id:"11",last:30},
         {name:"December",id:"12",last:31},
        ]

        dropdownSettings = {
          singleSelection: false,
          idField: 'item_id',
          textField: 'item_text',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: true
        };
        dropdownList:any = [];
        options:any=[];
        Team:any=[];





 SetFinalTeam(){

  this.data.team_mates=[]
  for(var i=0;i<this.selectedItems.length;i++){
    var obj={
      employee_id:this.selectedItems[i].item_id,
      employee_name:this.selectedItems[i].item_text
    }
    this.data.team_mates.push(obj)
  }
}

ChangeForm(){
  this.data.working_days=[];
  for(var i=0;i<this.model.length;i++){

    var d = new Date(this.model[i]);
    var timeZoneDifference = (d.getTimezoneOffset() / 60) * -1; //convert to positive value.
    d.setTime(d.getTime() + (timeZoneDifference * 60) * 60 * 1000);
    d.toISOString()
    this.data.working_days.push(d)

    //this.data.working_days.push((new Date(this.model[i]).toISOString()));
  }

 }

 SearchEmployee(){
  if(this.data.brand_manager_name!='')
  {
  this.isShownEmployee=true;
  }
  this.searchEmployee=this.data.brand_manager_name
  this.brandService.SearchEmployee(this.searchEmployee).subscribe((res)=>{
  this.employee=res.data
 
  })
}
 MonthSelected(value:any){
  this.model=[];
  this.MName="*";
  var year = new Date();
  let current_year=year.getFullYear()
 
  var month=this.Month[value].id
  this.data.month=current_year+"-"+month
  console.log("year=", this.data.month)

  //---------set max and min for calender-------
  var start=this.Month[value].id+"/"+"1"+"/"+current_year
  var end=this.Month[value].id+"/"+this.Month[value].last+"/"+current_year
  console.log("start=", end)
  this.minDate= new Date(start)
  this.maxDate= new Date(end)
  
}
 BrandSelected(value:any){

  console.log("value=",this.Brand[value])
  this.data.brand_id=this.Brand[value].brand_id
  this.data.brand_name=this.Brand[value].brand_name
}
//---------function for getting searched employee id---------------
getEmployeeId(value1:any,value2:any){
     
  this.isShownEmployee=false
  this.data.brand_manager_name=value2
  this.data.brand_manager_id=value1
  console.log("search result",this.data.employee_id)

}

valuechange4(newValue1: any) {
  console.log("Manager=",newValue1)
  this.data.brand_manager_name=newValue1
  this.Search_employee=""
}
//---------function for edit brand detail-----
btnClick()
{

  this.SetFinalTeam();
  this.ChangeForm();
  this.data.working_days=this.model
 

  console.log("Data=",this.data)

 // --------api for put----------//
  this.brandService.EditSalesTeam(this.data).subscribe((res) => {
    this.brandService.setSalesTeamId(this.TeamId)
    this.router.navigateByUrl(('admin/sales-team-view'));  

  })
}

SetModel(array:any){
  console.log("array=",array)
  var temp_date_array=[]
  for(var i=0;i<array.length;i++){

    temp_date_array.push(new Date(array[i]))

   }
   this.model =temp_date_array
}


onItemSelect(item: any) {
  console.log(item);
  console.log("one Item selected",this.selectedItems);

  // this.SetQuotationDetails1()
   this.TeamMates="*"
}
onSelectAll(items: any) {
  console.log(items);
  this.selectedItems=items
  console.log("All Item selected",this.selectedItems);

  this.TeamMates="*"
}
onDeSelect(item:any){
  console.log(item);
  console.log("Item De selected",this.selectedItems);
  
}
onDeSelecAll(){
  console.log("hai")
}
  ngOnInit(): void {


       //---call function in service for brand Id------
       this.TeamId=this.brandService.getSalesTeamId()
       console.log("Sales team Id=", this.TeamId)
       
       //-------api get()calling-------------
       this.brandService.ViewTeamById('/'+this.TeamId).subscribe((res)=>{
       this.output=res.data

       console.log("data=",  this.output)

       this.data._id=this.output[0]._id
       this.data.team_name=this.output[0].team_name

       this.data.brand_name=this.output[0].brand_name
       this.data.brand_manager_name=this.output[0].brand_manager_name

       this.data.brand_id=this.output[0].brand_id
       this.data.brand_manager_id=this.output[0].brand_manager_id
       
       this.data.month=this.output[0].month_year
       this.MonthName=this.output[0].month_year.substr(0,this.data.month.length - 4);

       console.log("days=",this.output[0].working_days.length)
       this.SetModel(this.output[0].working_days)
//-------set team member array--------------------------------//
       for(var i=0;i<this.output[0].team_mates.length;i++){  
        this.Team.push({ item_id: this.output[0].team_mates[i].employee_id, item_text: this.output[0].team_mates[i].employee_name});
      }
      
      this.selectedItems= this.Team
//--------set calender---------------------//
//---------set max and min for calender-------
//var start=this.Month[value].id+"/"+"1"+"/"+current_year
//var end=this.Month[value].id+"/"+this.Month[value].last+"/"+current_year
this.minDate= new Date(this.output[0].month_year)
this.maxDate= new Date(this.minDate.getFullYear(), this.minDate.getMonth() + 1, 0);


})
    

        this.brandService.ViewAllEmployee().subscribe((res)=>{

          for(var i=0;i<res.data.length;i++){
          
        
            this.options.push({ item_id: res.data[i].employee_id, item_text: res.data[i].employee_name});
      
          }
           console.log("option3=", this.options)
           this.dropdownList= this.options
        })

               //-------api for get department name---------
       this.brandService.BrandDropdown().subscribe((res)=>{
        this.Brand=res.data
        console.log("Brand details =",this.Brand)
        })

        this.brandService.ViewAllEmployee().subscribe((res)=>{

          for(var i=0;i<res.data.length;i++){
          
        
            this.options.push({ item_id: res.data[i].employee_id, item_text: res.data[i].employee_name});
      
          }
           console.log("option3=", this.options)
           this.dropdownList= this.options
        })
  }

}
